export default {
  isPageLoad(state) {
    state.pageLoad = true
    state.templateLoad = true
  },
  pageLoad(state) {
    state.pageLoad = false
    state.templateLoad = false
  },
  setApi(state, data) {
    state.api = data
  },
  setLk(state, data) {
    state.lk = data
  },
  setDomain(state, data) {
    state.domain = data
  },
  setToken(state, data) {
    state.token = data
  },
  setSocket(state, data) {
    state.socket = data
  },
  setUser(state, data) {
    if(data) {
      state.user = data
    }
  },
}


// WEBPACK FOOTER //
// ./src/store/mutations.js